export interface ICurrency {
  id: string | number
  code: string
  name: string
  isFiat: boolean | string
  description: string
  isTrackable: boolean | string
  walletFieldName: string
  availableSupply: number | string
  miningTotalCirculation: number | string
  marketCap: number | string
  btcVolume24Hour: number | string
  btcVolume1Hour: number | string
  btcPrice: number | string
  prevSlug: string
  nextSlug: string
  prevSlugName: string
  nextSlugName: string
  urlWebsite: string
}

export class Currency implements ICurrency {
  constructor(
    public id: string | number = '',
    public code: string = '',
    public name: string = '',
    public isFiat: boolean | string = '',
    public description: string = '',
    public isTrackable: boolean | string = '',
    public walletFieldName: string = '',
    public availableSupply: number | string = '',
    public miningTotalCirculation: number | string = '',
    public marketCap: number | string = '',
    public btcVolume24Hour: number | string = '',
    public btcVolume1Hour: number | string = '',
    public btcPrice: number | string = '',
    public prevSlug: string = '',
    public nextSlug: string = '',
    public prevSlugName: string = '',
    public nextSlugName: string = '',
    public urlWebsite: string = ''
  ) {}
}

export default Currency 